module.exports = __webpack_public_path__ + "img/circle-checked.bf9e7c5f.svg";